// modules
import React from "react";
import styled from "styled-components";
// assets
// styles
// components
// redux

const StyledIframeContainer = styled.div``;

const IframeBlock = (props) => {
    return (
        <StyledIframeContainer>
            <iframe
                title={`${props.src} iframe`}
                src={`${props.src}`}
                width="100%"
                height="500px"
                allowFullScreen={true}
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                style={{ border: "none" }}
            />
        </StyledIframeContainer>
    );
};

export default IframeBlock;
